<script setup>
import { getI18n } from '@/plugins/i18n'

import ExpandableContent from '@/components/shared/ExpandableContent.vue'

const i18n = getI18n()

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  collapsedHeight: {
    type: String,
    required: false,
    default: '2.45rem',
  },
  label: {
    type: String,
    required: false,
    default: null,
  },
})
</script>

<template>
  <q-item>
    <q-item-section>
      <expandable-content :label="props.label || i18n.t('common.description')" :collapsed-height="props.collapsedHeight">
        <div class="description-text">{{ props.text }}</div>
      </expandable-content>
    </q-item-section>
  </q-item>
</template>

<style scoped lang="scss">
.description-text {
  white-space: pre-wrap;
  font-size: 0.875rem;
  // 2 lines = 2 * 1.4 * 0.875rem, matching the default collapsedHeight
  line-height: 1.4;
}
</style>
